import { render, staticRenderFns } from "./InformativesPage.vue?vue&type=template&id=5da67082&scoped=true"
import script from "./InformativesPage.vue?vue&type=script&lang=js"
export * from "./InformativesPage.vue?vue&type=script&lang=js"
import style0 from "./InformativesPage.vue?vue&type=style&index=0&id=5da67082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da67082",
  null
  
)

export default component.exports